import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'messageRequire',
  standalone: true,
})
export class MessageRequirePipe implements PipeTransform {
  private translate = inject(TranslateService);

  transform(value: string): string {
    const currentLang = this.translate.getCurrentLang();

    if (currentLang === 'th') {
      return `ต้องระบุ${value}`;
    } else {
      // Default to English for any other language
      return `${value} is required`;
    }
  }
}
